import { forwardRef } from "react";
import type { ManualSection } from "@/content/manualTypes";
import { ManualBlockRenderer } from "./ManualBlocks";

type Props = {
  section: ManualSection;
  index: number;
};

export const ManualSectionBlock = forwardRef<HTMLElement, Props>(({ section, index }, ref) => (
  <section
    id={section.id}
    ref={ref}
    aria-labelledby={`${section.id}-title`}
    className="scroll-mt-28 border-b border-border/60 py-12 first:pt-4 last:border-b-0 sm:py-16"
  >
    <div className="mb-6 flex flex-wrap items-center gap-3">
      <span className="rounded-full border border-primary/40 bg-primary/10 px-3 py-1 font-mono text-xs tracking-widest text-primary">
        STEP {String(index + 1).padStart(2, "0")}
      </span>
      <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{section.navLabel}</span>
    </div>


    <h2 id={`${section.id}-title`} className="text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl">
      {section.title}
    </h2>

    {section.intro && (
      <p className="mt-4 max-w-[70ch] text-lg leading-relaxed text-foreground/70">{section.intro}</p>
    )}

    <div className="mt-8 space-y-6">
      {section.blocks.map((block, blockIndex) => (
        <ManualBlockRenderer key={`${section.id}-${blockIndex}`} block={block} />
      ))}
    </div>
  </section>
));

ManualSectionBlock.displayName = "ManualSectionBlock";
